/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { Component } from 'react';
import './BbQuestion.css';
import './BbBannerShared.css';

import BbTimer from './BbTimer';

class BbQuestion extends Component {
  shouldComponentUpdate(nextProps) {
    if (nextProps.mediaURI !== this.props.mediaURI) {
      return true;
    }
    return false;
  }

  render() {
    /*
    This timer goes back to the old brainbout where DIFFICULTY played
    a role in how many seconds each round took.  I leave most code in place
    so that the difficulty feature can be reimplemented in the
    future.  For now, this semantic-web version has a single
    hard-coded difficulty value.
    */
    const t = new Date().getUTCSeconds();
    const difficulty = 0; // TODO FF: no hardcoded vals

    console.log('*** QUESTION ***');
    const rootURI = '/wp-content/uploads/';
    const mediaURI = this.props.mediaURI !== undefined ? this.props.mediaURI : '2023/01/404-error-3060993_640.png';
    const mediaURL = rootURI + decodeURIComponent(mediaURI);
    return (
      <div className="container-fluid bg-secondary">
        <div className="row g-0">
          <div className="col center">
            <div id="bb_question" className="banner_shared">
              <div key="qmedia" className="center">
                <img
                  id="qimg"
                  onClick={this.enlargImg}
                  className="centerimg"
                  src={mediaURL}
                  alt=""
                  key="qimage"
                />
              </div>
            </div>

            <BbTimer key="tim" t={t} difficulty={difficulty} />

          </div>
        </div>
      </div>
    );
  }
}
export default BbQuestion;
